import type { ReactNode } from 'react';

const VARIANT_SYMBOL = Symbol.for('experiment-variant');

interface ExperimentVariantProps {
  name: string;
  children: ReactNode;
}

export function ExperimentVariant({ children }: ExperimentVariantProps) {
  return <>{children}</>;
}

(ExperimentVariant as { __experimentVariant?: symbol }).__experimentVariant = VARIANT_SYMBOL;

export { VARIANT_SYMBOL };
